(function() {
  var root = document.documentElement;
  var toggle = document.querySelector('[data-theme-toggle]');
  var label = document.querySelector('[data-theme-toggle-label]');
  var themeMeta = document.querySelector('meta[name="theme-color"]');

  if (!toggle || !root) {
    return;
  }

  function setTheme(theme, shouldPersist) {
    root.setAttribute('data-theme', theme);
    root.style.colorScheme = theme;

    if (themeMeta) {
      themeMeta.setAttribute('content', theme === 'dark' ? '#111111' : '#ffffff');
    }

    label.textContent = theme === 'dark' ? 'Light mode' : 'Dark mode';
    toggle.setAttribute('aria-pressed', String(theme === 'dark'));

    if (!shouldPersist) {
      return;
    }

    try {
      localStorage.setItem(storageKey, theme);
    } catch (e) {
      // noop
    }
  }

  var currentTheme = root.getAttribute('data-theme') || 'light';
  setTheme(currentTheme, false);

  toggle.addEventListener('click', function() {
    currentTheme = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    setTheme(currentTheme, true);
  });
})();
